import { render, staticRenderFns } from "./TwitterXIcon.vue?vue&type=template&id=2531dadc&"
import script from "./TwitterXIcon.vue?vue&type=script&lang=js&"
export * from "./TwitterXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports